document.addEventListener('DOMContentLoaded', function () {

  // Find every search form on the website
  const searchForms = document.querySelectorAll(
    'form[action*="/search"]'
  );

  /**
   * Convert Shopify's internal search syntax back
   * into normal text for the customer.
   *
   * Example:
   * title:ravioli* AND title:spinach*
   *
   * becomes:
   * ravioli spinach
   */
  function cleanSearchText(value) {
    if (!value) return '';

    // SKU search generated by this script:
    // (variants.sku:LIG0911* OR title:LIG0911*)
    // Display only LIG0911 to the customer.
    const skuMatch = value.match(
      /^\(variants\.sku:([^\s*]+)\*\s+OR\s+title:[^\s*]+\*\)$/i
    );

    if (skuMatch) {
      return skuMatch[1];
    }

    // Normal title search:
    // title:ravioli* AND title:spinach*
    // becomes: ravioli spinach
    return value
      .replace(/\s+AND\s+/gi, ' ')
      .replace(/title:/gi, '')
      .replace(/\*/g, '')
      .trim();
  }


  /**
   * Convert customer search into a title-only
   * partial search.
   *
   * Example:
   * rav
   *
   * becomes:
   * title:rav*
   *
   * Example:
   * ravioli spinach
   *
   * becomes:
   * title:ravioli* AND title:spinach*
   */
  function buildSearchQuery(value) {
    const cleanValue = cleanSearchText(value);

    if (!cleanValue) return '';

    const words = cleanValue
      .split(/\s+/)
      .filter(Boolean);

    // If customer enters a single term that looks like an SKU,
    // search both SKU and title.
    //
    // Examples:
    // LIG0911
    // CAS003
    // SRG013
    if (
      words.length === 1 &&
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9_-]+$/.test(words[0])
    ) {
      const word = words[0];

      return '(variants.sku:' + word + '* OR title:' + word + '*)';
    }

    // Normal product-name search keeps the existing
    // partial title-search behaviour.
    return words
      .map(function (word) {
        return 'title:' + word + '*';
      })
        .join(' AND ');
  }


  searchForms.forEach(function (form) {

    const searchInput = form.querySelector('input[name="q"]');

    if (!searchInput) return;


    // -----------------------------------------
    // PRODUCT-ONLY SEARCH
    // -----------------------------------------

    let typeInput = form.querySelector('input[name="type"]');

    if (!typeInput) {
      typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      form.appendChild(typeInput);
    }

    typeInput.value = 'product';


    // -----------------------------------------
    // CLEAN SEARCH TEXT SHOWN TO CUSTOMER
    // -----------------------------------------

    searchInput.value = cleanSearchText(searchInput.value);


    // -----------------------------------------
    // HANDLE SEARCH SUBMISSION
    // -----------------------------------------

    form.addEventListener('submit', function () {

      const customerSearch = searchInput.value.trim();

      if (!customerSearch) return;


      // Create a hidden field containing the
      // actual Shopify search query
      let hiddenQuery = form.querySelector(
        'input[data-visco-search-query]'
      );

      if (!hiddenQuery) {
        hiddenQuery = document.createElement('input');

        hiddenQuery.type = 'hidden';
        hiddenQuery.name = 'q';

        hiddenQuery.setAttribute(
          'data-visco-search-query',
          'true'
        );

        form.appendChild(hiddenQuery);
      }


      // Convert normal customer search into
      // Shopify title-only prefix search
      hiddenQuery.value = buildSearchQuery(customerSearch);


      // Prevent the visible search box from
      // submitting another "q" parameter
      searchInput.removeAttribute('name');
    });

  });

});